// extracted by mini-css-extract-plugin
export default {"table":"TopTable_table__Vdi2v","empty":"TopTable_empty__N2hXC"};